/**
 * UnAnonymous conversational lenses.
 *
 * Conversational lenses are user-facing values, not personas.
 * Internal ids remain stable so existing backend/session behavior is preserved.
 */
export const COMPANION_MODES = [
  {
    id: "clarity",
    name: "Truth",
    value: "Truth",
    icon: "gem",
    eyebrow: "Make sense of this",
    description: "Slow the moment down, separate signal from noise, and name what feels true without judgment.",
    starter: "What feels hardest to make sense of right now?",
    signature: null,
    accent: "plum",
  },
  {
    id: "joy",
    name: "Joy",
    value: "Joy",
    icon: "sparkles",
    eyebrow: "Find a little light",
    description: "Notice what is still alive, good, funny, beautiful, or worth keeping close — without forcing positivity.",
    starter: "What is one small thing that felt good, warm, or alive today?",
    signature: null,
    accent: "gold",
  },
  {
    id: "hope",
    name: "Hope",
    value: "Hope",
    icon: "sunrise",
    eyebrow: "See a way forward",
    description: "When you feel stuck or discouraged, find the next possible step instead of demanding a perfect plan.",
    starter: "What would make the next hour feel one degree more possible?",
    signature: null,
    accent: "rose",
  },
];

export const AMBIENT_SYMBOLS = [
  {
    id: "compassion",
    name: "Compassion",
    value: "Compassion",
    icon: "check-heart",
    description: "A quiet mark for care, kindness, small comforts, and choosing something that matters to you — an experience, rest, connection, or something you want to make room for.",
  },
  {
    id: "nurture",
    name: "Nurture",
    value: "Nurture",
    icon: "flower",
    description: "The steady thread of warmth, nurture, steadiness, and being cared for underneath the experience.",
  },
];

export const getCompanionMode = (id) =>
  COMPANION_MODES.find((mode) => mode.id === id) || COMPANION_MODES[0];
